import { ROUTES } from "../router";
import profileAPI from "../api/profileAPI";
import notificationAPI from '../api/notificationAPI'
import { setupConferenceChannel, setupNotificationChannel } from "./helpers/listeners";
import {initOneSignal} from "../helpers/onesignal";
import router from "../router";
import { storage } from "../helpers/storage";

const state = {
  attendee: {
    conference: {
      name: null,
      date: null,
      is_single_session: false,
      attendee_to_completion: false,
    },
    timezone: null,
    header: {},
  },
  tabs: [],
  CEInfoTabs: [],
  isFetching: false,
  notification: {
    enabled: false,
    text: '',
    type: 'warning'
  },
};

const actions = {
  async runConferenceListeners({ state, commit, dispatch }, {attendeeId, conferenceId}) {
    try {
      const echo = await dispatch('echoStore/initEcho', null, {root: true});
      const channel = `conference.${conferenceId}`;
      await setupConferenceChannel(echo, channel, {commit, dispatch, state});
    } catch (error) {
      console.error('Echo initialization error:', error);
    }
  },

  async runGlobalNotificationListener({ commit, dispatch }) {
    try {
      const echo = await dispatch('echoStore/initEcho', null, { root: true });
      const channel = 'conference.global';
      await setupNotificationChannel(echo, channel, { commit });
    } catch (error) {
      console.error('Echo initialization error:', error);
    }
  },

  async fetchAttendee({commit, state, dispatch}, {id}) {
    commit("updateIsFetching", true);

    try {
      const response = await profileAPI.fetch(id);
      commit("updateAttendee", response);
      commit("updateTabs", response);

      await storage.setItem('attendee_id', id);

      initOneSignal(id, router);

      await Promise.all([
        dispatch("fetchNotification", { attendeeId: id }),
        dispatch("runConferenceListeners", {
          attendeeId: id,
          conferenceId: state.attendee.conference_id
        }),
        dispatch("runGlobalNotificationListener")
      ]);

      return response;
    } catch (error) {
      throw error;
    } finally {
      commit("updateIsFetching", false);
    }
  },

  async fetchNotification({commit, state, dispatch}, {attendeeId}) {
    try {
      const response = await notificationAPI.fetch(attendeeId);
      commit("updateNotification", response.data.data);
    } catch (error) {
      console.error('Failed to fetch notification:', error);
    }
  },

  updateMyAgendaCount({commit}, {count}) {
    commit('updateMyAgendaCount', count);
  }
};

const mutations = {
  updateAttendee(state, payload) {
    state.attendee = {
      ...state.attendee,
      ...payload.data.data,
    };
  },

  updateConferenceStatus(state, status) {
    state.attendee.conference.has_ended = status;
  },

  updateNotification(state, payload) {
    state.notification = payload;

    if (payload.text?.length) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },

  updateMyAgendaCount(state, payload) {
    if (state.tabs?.length) {
      state.tabs[1].count = state.tabs[1].count + payload;
    }
  },

  updateTabs(state, payload) {
    const {attendee_id} = payload.data.data;
    state.tabs = [
      {
        name: 'Schedule',
        to: ROUTES.AGENDA_EVENT.replace(':attendeeId', attendee_id),
        show: payload.data.data?.tabs?.agenda,
      },
      {
        name: 'My Schedule',
        to: ROUTES.AGENDA_SCHEDULE.replace(':attendeeId', attendee_id),
        count: payload.data.data?.conference?.agenda_selected_count,
        show: payload.data.data?.tabs?.my_agenda,
      },
    ];

    state.CEInfoTabs = [
      {
        name: state.attendee.conference.remove_ce_information ? "Info" : "CE Info",
        to: ROUTES.CE_INFO_CES.replace(':attendeeId',attendee_id),
        show: true,
      },
      {
        name: 'My Certificate',
        to: ROUTES.CERTIFICATE.replace(':attendeeId',attendee_id),
        show: payload.data.data?.tabs?.my_certificate,
      },]

    if (payload.data.data?.conference?.is_single_session) {
      state.tabs = [];
    }
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },
};

const getters = {
  attendee(state) {
    return state.attendee;
  },

  attendeeId(state) {
    return state.attendee?.attendee_id;
  },

  tabs(state) {
    return state.tabs;
  },

  sidebarMenu(state) {
    return state.attendee.header;
  },

  CEInfoTabs(state) {
    return state.CEInfoTabs;
  },

  isSingleSession(state) {
    return state.attendee.conference.is_single_session;
  },

  conferenceHasEnded(state) {
    return state.attendee.conference.has_ended;
  },

  attendeeToCompletion(state) {
    return state.attendee.conference.attendee_to_completion;
  },

  showMySchedule(state) {
    return state.attendee?.tabs?.my_agenda;
  },

  conferenceId(state) {
    return state.attendee.conference.id;
  },

  hideCeInformation(state) {
    return state.attendee.conference.remove_ce_information;
  },

  notification(state) {
    return state.notification;
  },

  showUpgradeTicketMenu(state) {
    return state.attendee.has_available_addons;
  },

  welcomeMessageText(state) {
    return state.attendee.welcome_message;
  },

  isFetching(state) {
    return state.isFetching;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
